import React from 'react';
export function HowItWorks() {
  return <section className="bg-navy-900 px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-98">
      <div className="mx-auto max-w-4xl" data-id="element-99">
        <div className="mb-16 text-center" data-id="element-100">
          <h2 className="mb-6 text-4xl sm:text-5xl font-bebas text-white" data-id="element-101">
            Cómo Funciona en{' '}
            <span className="text-gold-400" data-id="element-102">3 Pasos Simples</span>
          </h2>
        </div>

        <div className="relative" data-id="element-103">
          {/* Connecting line for desktop */}
          <div className="absolute left-[2.25rem] top-8 bottom-8 hidden w-0.5 bg-slate-700 md:block" data-id="element-104"></div>

          <div className="space-y-12" data-id="element-105">
            {/* Step 1 */}
            <div className="relative flex flex-col md:flex-row gap-6 md:gap-8" data-id="element-106">
              <div className="flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full bg-navy-800 border-2 border-gold-400 text-2xl font-bebas text-gold-400 shadow-[0_0_15px_rgba(212,168,67,0.2)] z-10" data-id="element-107">
                1
              </div>
              <div className="flex-1 rounded-2xl bg-navy-800 p-6 border border-slate-700/50" data-id="element-108">
                <h3 className="mb-3 text-2xl font-bebas text-white" data-id="element-109">
                  Auditoría
                </h3>
                <p className="text-slate-300" data-id="element-110">
                  Descargas tus reportes oficiales y localizas los errores
                  técnicos usando nuestra lupa de auditoría.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="relative flex flex-col md:flex-row gap-6 md:gap-8" data-id="element-111">
              <div className="flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full bg-navy-800 border-2 border-gold-400 text-2xl font-bebas text-gold-400 shadow-[0_0_15px_rgba(212,168,67,0.2)] z-10" data-id="element-112">
                2
              </div>
              <div className="flex-1 rounded-2xl bg-navy-800 p-6 border border-slate-700/50" data-id="element-113">
                <h3 className="mb-3 text-2xl font-bebas text-white" data-id="element-114">Disputa</h3>
                <p className="text-slate-300" data-id="element-115">
                  Redactas tus cartas siguiendo nuestro lenguaje legal probado y
                  las envías por correo certificado.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="relative flex flex-col md:flex-row gap-6 md:gap-8" data-id="element-116">
              <div className="flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full bg-green-500 border-2 border-green-400 text-2xl font-bebas text-white shadow-[0_0_20px_rgba(34,197,94,0.4)] z-10" data-id="element-117">
                3
              </div>
              <div className="flex-1 rounded-2xl bg-gradient-to-r from-navy-800 to-navy-900 p-6 border border-green-500/30" data-id="element-118">
                <h3 className="mb-3 text-2xl font-bebas text-green-400" data-id="element-119">
                  Resultado
                </h3>
                <p className="text-slate-300" data-id="element-120">
                  Esperas 35 días para ver cómo las cuentas negativas caen y tu
                  puntaje comienza su ascenso explosivo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}